import React from 'react';
import Wrapper from './styles';
import { formatPrice } from '../../utils/helpers';
import { Link } from 'react-router-dom';

const Product = ({ image, name, price, id }) => {
  return (
    <Wrapper>
      <Link to={`/products/${id}`} className='product-link'>
        <div className='container'>
          <img src={image} alt={name} referrerPolicy='no-referrer' />
        </div>
        <footer>
          <h5>{name}</h5>
          <p>{formatPrice(price)}</p>
        </footer>
      </Link>
    </Wrapper>
  );
};

export default Product;
